import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 月例テスト成績詳細取得
 */
export namespace ApiTaRe040 {
  // API Name
  export const name: string = 'ApiTaRe040'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/monthlyTestResult'

    export interface Request {
      query: {
        fiscalYear: number
        month: number
        times: number
        grade: number
        courseId: string
      }
    }

    export interface Response {
      monthlyTestResults: {
        memNum: string
        title: string
        gradeDataResults: {
          subjectCode: string
          answerId: string
          score: string
          average: string
          deviationValue: string
        }[]
        difficultyResults: {
          subjectCode: string
          resultsByQuestion:
            | {
                pieceId: string
                unitId: string
                contentId: string
                questionNo: number
                basicsScoreRate: string
                practicalScoreRate: string
              }[]
            | null
        }[]
      }
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        monthlyTestResults: {
          memNum: '',
          title: '',
          gradeDataResults: [
            {
              subjectCode: '',
              answerId: '',
              score: '',
              average: '',
              deviationValue: '',
            },
          ],
          difficultyResults: [
            {
              subjectCode: '',
              resultsByQuestion: [
                {
                  pieceId: '',
                  unitId: '',
                  contentId: '',
                  questionNo: 0,
                  basicsScoreRate: '',
                  practicalScoreRate: '',
                },
              ],
            },
          ],
        },
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
